const DEMOCRAT = [
  '#3486ff',
  '#619f1b',
  '#79c9ab',
  '#0d5979',
  '#69d6fd',
  '#bcdce8',
];

const REPUBLICAN = [
  '#f24b4b',
  '#a40554',
  '#c075e3',
  '#6b22bd',
  '#ff8f05',
  '#ffabab',
];

const NEUTRAL = '#d1d1d1';
const TIE = '#999999';

export { DEMOCRAT, NEUTRAL, REPUBLICAN, TIE };



// WEBPACK FOOTER //
// ./colors.js